import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from 'modules/navigation/navigation.actions';
import { Row, Button } from 'modules/styled';
import AppStoreButtons from 'modules/web_about/appStoreButtons';

Banner.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
};

export default function Banner({ location, history }) {
  const dispatch = useDispatch();
  const screenSize = useSelector((state) => state.navigation.screenSize);

  if (screenSize > 0) return <AppStoreButtons sx={{ mt: [4, 8], mb: [1, 0] }} />;

  const setRedirect = () =>
    history.replace({ search: `?redirect=${location?.pathname}` });

  return (
    <Row sx={{ justifyContent: 'flex-start' }}>
      <Button
        onPress={() => {
          setRedirect();
          dispatch(showModal('login'));
        }}
        sx={{ mr: 4 }}
      >
        Login
      </Button>
      <Button
        onPress={() => {
          setRedirect();
          dispatch(showModal('signupSocial'));
        }}
        sx={{ mr: 0 }}
      >
        Sign Up
      </Button>
    </Row>
  );
}
